import { forwardRef } from 'react';
import cx from 'clsx';

export interface LinkProps {
  className?: string;
  href?: string;
  linkType: 'inline' | 'popup';
  children?: React.ReactNode;
  title?: string;
  external?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const linkStyle = {
  inline: 'text-action-link hover:text-action-link-hover',
  popup: 'hover:bg-action-focus hover:text-text-body text-white',
};

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    { className, href, external, onClick, children, linkType, title, ...props },
    ref,
  ) => {
    const isExternal = external ?? false;

    const handleOnClick = (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
      if (!href && onClick) {
        event.preventDefault();
        onClick(event);
      }
    };

    return (
      <a
        href={href ?? '#'}
        className={cx(`${linkStyle[linkType]} font-bold underline`, className)}
        ref={ref}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        title={title}
        onClick={handleOnClick}
        {...props}
      >
        {children}
      </a>
    );
  },
);

Link.displayName = 'Link';
